<template lang="html">
  <div class="evaluations">

    <div class="container">
      <div class="row"> <!-- Titulo -->
        <h2 class="title">{{$t('telas.avaliacao.titulo')}}</h2>
      </div>

      <div class="row">
        <div class="col-12 col-sm-12 
                    col-md-8 offset-md-2
                    col-lg-8 offset-lg-2
                    col-xl-8 offset-xl-2
                    evaluation">
          <!-- https://www.booking.com/reviews/br/hotel/pousada-tranquilandia-village.pt-br.html -->
          <div class="content-evaluation">

            <div class="title-div-evaluation">
              <h4>{{$t('telas.avaliacao.descricao.avaliacao.titulo')}}</h4>
            </div>
            <hr>
            
            <p style="font-size:12px"><strong>* {{$t('telas.avaliacao.descricao.avaliacao.font_avaliacao')}}</strong></p>
            <h1>9,1</h1>
            <p>{{$t('telas.avaliacao.descricao.avaliacao.media')}}</p>
            <div class="score-bar">
              <div class="score" id="media">
              </div>
            </div><br>

            <div class="row">
              <div class="col-md-6 col-lg-6">
                <h4>9,3</h4>
                <p>{{$t('telas.avaliacao.descricao.avaliacao.limpeza')}}</p>
                <div class="score-bar">
                  <div class="score" id="limpeza">
                  </div>
                </div><br>
              </div>

              <div class="col-md-6 col-lg-6">
                <h4>9,1</h4>
                <p>{{$t('telas.avaliacao.descricao.avaliacao.conforto')}}</p>
                <div class="score-bar">
                  <div class="score" id="conforto">
                  </div>
                </div><br>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 col-lg-6">
                <h4>9,4</h4>
                <p>{{$t('telas.avaliacao.descricao.avaliacao.localizacao')}}</p>
                <div class="score-bar">
                  <div class="score" id="localizacao">
                  </div>
                </div><br>
              </div>

              <div class="col-md-6 col-lg-6">
                <h4>9,0</h4>
                <p>{{$t('telas.avaliacao.descricao.avaliacao.comodidade')}}</p>
                <div class="score-bar">
                  <div class="score" id="comodidade">
                  </div>
                </div><br>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 col-lg-6">
                <h4>9,3</h4>
                <p>{{$t('telas.avaliacao.descricao.avaliacao.funcionario')}}</p>
                <div class="score-bar">
                  <div class="score" id="funcionarios">
                  </div>
                </div><br>
              </div>

              <div class="col-md-6 col-lg-6">
                <h4>8,6</h4>
                <p>{{$t('telas.avaliacao.descricao.avaliacao.custo_beneficio')}}</p>
                <div class="score-bar">
                  <div class="score" id="custo-beneficio">
                  </div>
                </div><br>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6 offset-md-3 col-lg-6 offset-lg-3">
                <h4>8,4</h4>
                <p>{{$t('telas.avaliacao.descricao.avaliacao.wifi')}}</p>
                <div class="score-bar">
                  <div class="score" id="wifi">
                  </div>
                </div><br>
              </div>
            </div>

          </div>

        </div>
      </div> <!-- row -->

      <!-- reserva -->
      <reserva :header="true"></reserva>

    </div> <!-- Container -->
  </div>
</template>

<script>
import reserva from '../../components/reservation-component/ReservationComponent'

export default {
  name: 'Evaluation',

  components: {
    reserva
  }
}
</script>

<style lang="css">
.evaluations {
  /* background-color: #EFEFEF; */
  background-image: url('../../assets/img/bg.png');
  background-repeat: repeat;
  font-family: 'Quicksand', sans-serif;
  padding-bottom: 80px;
  padding-top: 100px;
}
.evaluations .container .row h2.title {
  width: 100%;
  text-align: center;
  color: rgb(118, 106, 49);
  margin-bottom: 40px;
}

.evaluations .container .row .content-evaluation {
  background-color: rgb(23, 162, 184);
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 20px;
}
.evaluations .container .row .content-evaluation .title-div-evaluation h4 {
  text-align: center;
  margin-top: 10px;
  color: white;
}
.evaluations .container .row .content-evaluation form.form-evaluation .row-form label,
.evaluations .container .row .evaluation .content-evaluation h1,
.evaluations .container .row .evaluation .content-evaluation h4,
.evaluations .container .row .evaluation .content-evaluation p {
  color: white;
}

.evaluations .container .row .evaluation h1 {
  margin: 0;
}
.evaluations .container .row .evaluation p {
  margin: 0;
}
.score-bar {
  background-color: #FFF;
  border: 1px solid #CCC;
  border-radius: 3px;
}
.score-bar .score {
   padding: 3px;
   background-color: rgb(23, 184, 120);
   border-radius: 3px;
}
.score-bar #media {
   width: 91%;
}
.score-bar #limpeza {
   width: 93%;
}
.score-bar #conforto {
   width: 91%;
}
.score-bar #localizacao {
   width: 94%;
}
.score-bar #comodidade {
   width: 90%;
}
.score-bar #funcionarios {
   width: 93%;
}
.score-bar #custo-beneficio{
   width: 86%;
}
.score-bar #wifi{
   width: 84%;
}
</style>



// WEBPACK FOOTER //
// src/pages/evaluation/Evaluation.vue